import { sanitizeRiderHtmlForExport } from './writerFormat';

/**
 * Open a print-ready window for the day rider (Save as PDF via browser print).
 * @param {{ html: string, title?: string, subtitle?: string, includeLinkUrls?: boolean }} opts
 */
export function openRiderPrintWindow({ html, title = 'Hospitality Rider', subtitle = '', includeLinkUrls = true }) {
  if (typeof window === 'undefined' || typeof document === 'undefined') return;

  const bodyHtml = sanitizeRiderHtmlForExport(html);
  const linkPrintCss = includeLinkUrls
    ? `
      a[href^="http"]:after,
      a[href^="https"]:after,
      a[href^="mailto"]:after {
        content: " (" attr(href) ")";
        font-size: 0.85em;
        color: #555;
        word-break: break-all;
      }
      .vrc-writer-link-btn:after {
        content: " (" attr(href) ")";
        display: block;
        font-size: 0.8em;
        font-weight: 500;
        margin-top: 4px;
        color: #555;
      }
    `
    : '';

  const printHtml = `<!DOCTYPE html>
<html>
<head>
  <meta charset="utf-8" />
  <title>${escapeHtml(title)}</title>
  <style>
    @page { margin: 18mm 16mm; }
    body {
      font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
      color: #111;
      line-height: 1.55;
      font-size: 13px;
      max-width: 720px;
      margin: 0 auto;
      padding: 24px;
    }
    h1 { font-size: 24px; font-weight: 800; text-align: center; margin: 0 0 6px; letter-spacing: 0.04em; text-transform: uppercase; }
    .subtitle { text-align: center; font-size: 14px; font-weight: 700; margin: 0 0 24px; text-transform: uppercase; letter-spacing: 0.06em; }
    h2 { font-size: 16px; font-weight: 800; margin: 18px 0 8px; text-transform: uppercase; text-decoration: underline; }
    p { margin: 0 0 10px; }
    ul { margin: 0 0 12px 20px; padding: 0; }
    a { color: #1a56db; }
    .vrc-writer-link-btn {
      display: inline-block;
      padding: 10px 18px;
      border-radius: 8px;
      background: #4e7de0;
      color: #fff !important;
      text-decoration: none;
      font-weight: 700;
      margin: 8px 0;
    }
    .vrc-writer-member {
      border: 1px solid #ddd;
      border-radius: 12px;
      padding: 12px;
      margin: 12px 0;
      background: #fafafa;
      page-break-inside: avoid;
    }
    .vrc-writer-member-header { display: flex; gap: 10px; align-items: flex-start; }
    .vrc-writer-member-photo {
      width: 44px; height: 44px; border-radius: 50%; object-fit: cover; border: 1.5px solid #ddd;
    }
    .vrc-writer-member-photo-fallback {
      display: inline-flex; align-items: center; justify-content: center;
      background: #eee; color: #333; font-weight: 800; font-size: 16px;
    }
    .vrc-writer-member-name { font-weight: 800; font-size: 14px; }
    .vrc-writer-member-email { font-size: 11px; color: #666; margin-top: 2px; }
    .vrc-writer-member-type {
      display: inline-block; font-size: 10px; font-weight: 700; padding: 2px 8px;
      border-radius: 999px; border: 1px solid #888; margin-top: 5px;
    }
    .vrc-writer-member-notes { margin-top: 8px; color: #444; font-size: 12px; }
    ${linkPrintCss}
    @media print {
      body { padding: 0; }
    }
  </style>
</head>
<body>
  <h1>${escapeHtml(title)}</h1>
  ${subtitle ? `<div class="subtitle">${escapeHtml(subtitle)}</div>` : ''}
  <div class="rider-content">${bodyHtml || '<p><em>No rider content yet.</em></p>'}</div>
  <script>
    window.onload = function() {
      setTimeout(function() { window.print(); }, 250);
    };
  </script>
</body>
</html>`;

  const win = window.open('', '_blank', 'noopener,noreferrer');
  if (!win) {
    throw new Error('Pop-up blocked. Allow pop-ups to print the rider PDF.');
  }
  win.document.open();
  win.document.write(printHtml);
  win.document.close();
}

function escapeHtml(value) {
  return String(value || '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}
